import MigrationDetails from './MigrationDetails';

export default MigrationDetails;
